import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ACHRecord } from 'src/app/models/ach_record.model';
import { ACHRecordService } from 'src/app/services/ach_record_service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-view-ach-data-dialog',
    templateUrl: './view-ach-data-dialog.component.html',
    styleUrls: ['./view-ach-data-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIconButton, MatSuffix, MatIcon, MatDialogActions, MatButton, MatDialogClose]
})
export class ViewAchDataDialogComponent implements OnInit {
  hideRoutingNumber = true;
  hideAccountNumber = true;
  achRecord!: ACHRecord;

  achRecordFormGroup = new UntypedFormGroup({
    bankName: new UntypedFormControl({ disabled: true }),
    routingNumber: new UntypedFormControl({ disabled: true }),
    accountNumber: new UntypedFormControl({ disabled: true }),
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ACHRecord,
    private achRecordService: ACHRecordService,
  ) {}

  ngOnInit() {
    this.getACHRecord();
  }

  setValues(): void {
    this.achRecordFormGroup.controls.bankName.setValue(this.achRecord.bankName);
    this.achRecordFormGroup.controls.bankName.disable();
    this.achRecordFormGroup.controls.accountNumber.setValue(this.achRecord.accountNumber);
    this.achRecordFormGroup.controls.accountNumber.disable();
    this.achRecordFormGroup.controls.routingNumber.setValue(this.achRecord.routingNumber);
    this.achRecordFormGroup.controls.routingNumber.disable();
  }

  getACHRecord(): void {
    const queryParams = new Map();
    this.achRecordService.get([this.data.achRecordId], queryParams).subscribe((result) => {
      this.achRecord = result;
      this.setValues();
    });
  }
}
